import { SHOW_MENU } from './types'
import { HIDE_MENU } from './types'


export const showSideMenu = () => dispatch => {  
        dispatch({
            type: SHOW_MENU, 
            payload: "SideMenuOpen"
        })
}
export const hideSideMenu = () => dispatch => {
    dispatch({
        type: HIDE_MENU, 
        payload: "SideMenu"
    })
}



// WEBPACK FOOTER //
// ./src/Actions/MyHavenSideMenuAction.js